// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1945":"16fe78f6","5112":"d6a0fb6a","6262":"09a80baf","7301":"04d3df29"}[chunkId] + ".chunk.css";
};